import { API_URL } from 'constants/global';
const _fetch = typeof window === 'undefined' ? require('node-fetch') : window.fetch;

const postJSON = (url, data) => {
  // @ts-ignore
  const req = _fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Cross-Origin-Resource-Policy': 'cross-origin',
      'Accept-Language': 'ru',
    },
    body: JSON.stringify(data),
  });

  return req.then(res => {
    if (!res.ok) {
      return res.text().then(text => {
        try {
          const errorData = JSON.parse(text);
          return {
            status: res.status,
            error: errorData.error || 'Unknown error',
            messages: errorData.messages || {},
          };
        } catch {
          throw {
            status: res.status,
            error: text || 'Unknown error',
            messages: {},
          };
        }
      });
    }

    return res;
  });
};

export const sendMainForm = async data => postJSON(`${API_URL}traineeship`, data);
export const getCaptchaToken = () =>
  // @ts-ignore
  window?.grecaptcha
    .execute('6LdyHYgiAAAAAMhEWylinM6Abzw7tokplKkypSIX', {
      action: 'submit',
    })
    .catch(() => 'no-token');
